import { useState } from 'react'
import AnswerFaqComponent from '../Components/UI/AnswerFaqComponent'
import DocumentComponent from '../Components/UI/DocumentComponent'
import FaqComponent from '../Components/UI/FaqComponent'

const SearchComponent = ({ payload }) => {
  const { answerFaq, documents, faq, queryId, resultId } = payload

  const [expandedFaqResultId, setExpandedFaqResultId] = useState(null)

  const toggleFaq = (resultId) => {
    setExpandedFaqResultId(prevId => (prevId === resultId ? null : resultId))
  }

  const components = {
    renderDocuments: () => <DocumentComponent documents={documents} queryId={queryId} />,
    renderAnswerFaq: () => <AnswerFaqComponent answerFaq={answerFaq} queryId={queryId} resultId={resultId} />,
    renderFaqs: () => (
      <FaqComponent
        faq={faq} expandedFaqResultId={expandedFaqResultId} toggleFaq={toggleFaq} queryId={queryId} />
    )
  }

  return (
    <>
      {documents && !faq && !answerFaq && components.renderDocuments()}

      {answerFaq && !documents && !faq && components.renderAnswerFaq()}

      {answerFaq && documents && !faq && (
        <>
          <div className="answer-faq-component">{components.renderAnswerFaq()}</div>
          <div className="document-component">{components.renderDocuments()}</div>
        </>
      )}

      {documents && faq && !answerFaq && (
        <>
          <div className="document-component">{components.renderDocuments()}</div>
          <div> {components.renderFaqs()}</div>
        </>
      )}

      {answerFaq && faq && !documents && (
        <>
          <div className="answer-faq-component">{components.renderAnswerFaq()}</div>
          <div> {components.renderFaqs()}</div>
        </>
      )}

      {answerFaq && documents && faq && (
        <>
          <div className="answer-faq-component">{components.renderAnswerFaq()}</div>
          <div className="document-component">{components.renderDocuments()}</div>
          <div> {components.renderFaqs()}</div>
        </>
      )}
    </>
  )
}

export default SearchComponent